import { Option } from '@/common/types/option'

export const stateOptions: Option[] = [
  { value: 'registered', label: 'Cadastrou a empresa' },
  { value: 'qualifying', label: 'Iniciou Qualificação' },
  { value: 'qualifying_management_review', label: 'Enviou para análise do gestor' },
  { value: 'qualifying_finantial_review', label: 'Enviou para análise financeira' },
  { value: 'quoting', label: 'Devolveu para geração de condição comercial' },
  { value: 'quoting_management_review', label: 'Gerando condição comercial. Em análise pelo gestor' },
  { value: 'quoting_client_review', label: 'Enviou condição comercial para clientes' },
  { value: 'quoting_finalization', label: 'Condição comercial aprovada pelos clientes' },
  { value: 'negotiating', label: 'Enviou para implantação' },
]
